var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(_vm._s(_vm.pageTitle))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", {
            staticClass: "alertClass",
            attrs: { id: "success-alert" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "forms-container add_user_forms_container" },
            [
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.eventDetails.class_name))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 forms-block" },
                    [
                      _vm.eventDetails.already_register == true &&
                      _vm.eventDetails.is_register
                        ? [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showRegisterBtn,
                                    expression: "showRegisterBtn"
                                  }
                                ],
                                staticClass: "form-control btn-danger",
                                on: {
                                  click: function($event) {
                                    return _vm.cancelRegistration()
                                  }
                                }
                              },
                              [_vm._v("Cancel Registration")]
                            )
                          ]
                        : [
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showRegisterBtn,
                                    expression: "showRegisterBtn"
                                  }
                                ],
                                staticClass: "form-control btn-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.registerToClass()
                                  }
                                }
                              },
                              [_vm._v("Register")]
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.eventDetails.participation_cap))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.eventDetails.meeting_link))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.capitalizeFirstLetter(
                              _vm.eventDetails.class_name
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.eventDetails.class_type === "recurring" &&
                  _vm.eventDetails.recurring_type === "weekly"
                    ? [
                        _c("div", { staticClass: "col-6 forms-block" }, [
                          _vm._m(3),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-9 paddingleft0" }, [
                            _c("label", { staticClass: "form-label" }, [
                              _vm._v(_vm._s(_vm.eventDetails.week_day))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4" }, [
                          _c("div", { staticClass: "col-12 paddingleft0" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-label",
                                staticStyle: { "font-weight": "bold" },
                                attrs: { slot: "before", for: "startTime" },
                                slot: "before"
                              },
                              [_vm._v("Start Time :")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 paddingleft0" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.eventDetails.week_day_start_time)
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4" }, [
                          _c("div", { staticClass: "col-12 paddingleft0" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-label",
                                staticStyle: { "font-weight": "bold" },
                                attrs: { slot: "before", for: "endTime" },
                                slot: "before"
                              },
                              [_vm._v("End Time :")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 paddingleft0" }, [
                            _c("p", [
                              _vm._v(_vm._s(_vm.eventDetails.week_day_end_time))
                            ])
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventDetails.class_type === "normal" ||
                  (_vm.eventDetails.class_type == "recurring" &&
                    _vm.eventDetails.recurring_type == "monthly") ||
                  (_vm.eventDetails.class_type == "recurring" &&
                    _vm.eventDetails.recurring_type == "yearly")
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 forms-block d-flex justify-content-between"
                          },
                          [
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 paddingleft0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-label",
                                      staticStyle: { "font-weight": "bold" },
                                      attrs: {
                                        slot: "before",
                                        for: "startDate"
                                      },
                                      slot: "before"
                                    },
                                    [_vm._v("Date :")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 paddingleft0" },
                                [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.eventDetails.start_date))
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 paddingleft0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-label",
                                      staticStyle: { "font-weight": "bold" },
                                      attrs: {
                                        slot: "before",
                                        for: "startTime"
                                      },
                                      slot: "before"
                                    },
                                    [_vm._v("Start Time :")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 paddingleft0" },
                                [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.eventDetails.start_time))
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-4" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 paddingleft0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-label",
                                      staticStyle: { "font-weight": "bold" },
                                      attrs: { slot: "before", for: "endTime" },
                                      slot: "before"
                                    },
                                    [_vm._v("End Time :")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 paddingleft0" },
                                [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.eventDetails.end_time))
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventDetails.class_type == "multipledate"
                    ? [
                        _vm._l(_vm.eventDetails.inputs, function(input, index) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 forms-block d-flex justify-content-between"
                              },
                              [
                                _c("div", { staticClass: "col-4" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 paddingleft0" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-label",
                                          staticStyle: {
                                            "font-weight": "bold"
                                          },
                                          attrs: {
                                            slot: "before",
                                            for: "endTime"
                                          },
                                          slot: "before"
                                        },
                                        [_vm._v("Date")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 paddingleft0" },
                                    [_c("p", [_vm._v(_vm._s(input.startDate))])]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-4" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 paddingleft0" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-label",
                                          staticStyle: {
                                            "font-weight": "bold"
                                          },
                                          attrs: {
                                            slot: "before",
                                            for: "endTime"
                                          },
                                          slot: "before"
                                        },
                                        [_vm._v("Start Time")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 paddingleft0" },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(input.startTime.text))
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-4" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 paddingleft0" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-label",
                                          staticStyle: {
                                            "font-weight": "bold"
                                          },
                                          attrs: {
                                            slot: "before",
                                            for: "endTime"
                                          },
                                          slot: "before"
                                        },
                                        [_vm._v("End Time")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 paddingleft0" },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(input.endTime.text))
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.eventDetails.description != ""
                    ? [
                        _c("div", { staticClass: "col-12 forms-block" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-9 paddingleft0" }, [
                            _c("div", {
                              staticClass: "form-label",
                              domProps: {
                                innerHTML: _vm._s(_vm.eventDetails.description)
                              }
                            })
                          ])
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _vm.eventDetails.already_register == true &&
              _vm.eventDetails.is_register
                ? [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ]
                : _vm.eventDetails.is_class_full == true
                ? [
                    _c("p", { staticStyle: { color: "red" } }, [
                      _vm._v("Sorry class is full!")
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showRegisterBtn,
                            expression: "showRegisterBtn"
                          }
                        ],
                        staticClass: "form-control btn-primary",
                        on: {
                          click: function($event) {
                            return _vm.registerToClass()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "Register ( " +
                            _vm._s(_vm.eventDetails.waiting) +
                            " Waiting )"
                        )
                      ]
                    )
                  ]
                : _vm.eventDetails.attented == true
                ? void 0
                : _vm.eventDetails.dependent_class_not_attand == true
                ? [
                    _c("p", { staticStyle: { color: "red" } }, [
                      _vm._v("You are not eligible for this class!")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        "You need to attand the " +
                          _vm._s(
                            _vm.eventDetails.dependent_class_not_attand_string
                          ) +
                          " classes."
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 forms-block participant" },
                [
                  _c("h1", [_vm._v(" Participant(s)")]),
                  _vm._v(" "),
                  _vm._l(_vm.eventDetails.participants, function(
                    participant_user
                  ) {
                    return [
                      _c("div", { staticClass: "col-12 forms-block" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(participant_user.name) +
                            "\n                        "
                        )
                      ])
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.eventDetails.gallery_media
                ? [
                    _c("div", { staticClass: "row clearfix" }),
                    _vm._v(" "),
                    _c("h1", { staticStyle: { "text-align": "center" } }, [
                      _vm._v("Already Uploaded Media")
                    ]),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._l(_vm.eventDetails.gallery_media, function(
                      media,
                      index
                    ) {
                      return [
                        _c(
                          "div",
                          { staticClass: "row bulletin-board-listing" },
                          [
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(media.name) +
                                    "\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(media.description) +
                                    " \n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              _c(
                                "div",
                                { staticClass: "form-group text-center" },
                                [
                                  media.content_type === "image/jpeg" ||
                                  media.content_type === "image/png" ||
                                  media.content_type === "image/gif"
                                    ? [
                                        _c("img", {
                                          attrs: {
                                            width: "100%",
                                            src: _vm.s3_url + media.path,
                                            alt: "Maia Parsons",
                                            height: "150px;"
                                          }
                                        })
                                      ]
                                    : media.content_type === "video/mp4"
                                    ? [
                                        _c(
                                          "video",
                                          {
                                            attrs: {
                                              width: "100%",
                                              controls: "controls",
                                              preload: "metadata"
                                            }
                                          },
                                          [
                                            media.path != ""
                                              ? [
                                                  _c("source", {
                                                    attrs: {
                                                      src:
                                                        _vm.s3_url +
                                                        media.path +
                                                        "#t=0.5",
                                                      type: "video/mp4"
                                                    }
                                                  })
                                                ]
                                              : [
                                                  _c("source", {
                                                    attrs: {
                                                      src: "",
                                                      type: "video/mp4"
                                                    }
                                                  })
                                                ]
                                          ],
                                          2
                                        )
                                      ]
                                    : [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.s3_url + media.path,
                                              download: ""
                                            }
                                          },
                                          [_vm._v("Download")]
                                        )
                                      ]
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      ]
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("Participation Cap :")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("Link :")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", staticStyle: { "font-weight": "bold" } },
        [_vm._v("Class Name :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", staticStyle: { "font-weight": "bold" } },
        [_vm._v("Day Of Week :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c(
        "div",
        { staticClass: "form-label", staticStyle: { "font-weight": "bold" } },
        [_vm._v("Description :")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-sm-12 col-md-12 col-lg-12" }, [
      _c("div", { staticClass: "form-group" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "form-group bold" }, [
          _vm._v("\n                            Name\n                        ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "form-group bold" }, [
          _vm._v(
            "\n                            Description\n                        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "form-group bold text-center" }, [
          _vm._v(
            "\n                            Media\n                        "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-482a12cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-482a12cb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonModelForClass/CommonClassDetailPage.vue
// module id = null
// module chunks = 